<template>
  <div class="wishlist-item-wrapper d-flex justify-space-between align-start mb-16">
    <div style="position: relative">
      <div class="voucher-image rounded-lg elevation-3" v-if="item.product_category_id === 7">
        <v-img src="@/assets/voucher-detail.png" aspect-ratio="1" width="100%" height="100%" contain />
      </div>
      <v-img v-else :src="item.image" class="wishlist-image rounded-lg elevation-3" :class="{ 'unavailable-item': item.stock_status !== 'In Stock' }" aspect-ratio="1" />
      <div v-if="item.discount_percentage != 0" class="discount font-weight-bold primary lighten-1 d-flex flex-column align-center justify-center white--text rounded-circle">
        <span>{{ item.discount_percentage }}%</span>
        <span>{{ $t('label.discountOff') }}</span>
      </div>
    </div>
    <div
      class="d-flex w-100 ml-5"
      :class="{
        'flex-row justify-space-between align-start': $vuetify.breakpoint.smAndUp,
        'flex-column justify-space-between align-start': !$vuetify.breakpoint.smAndUp
      }"
    >
      <div>
        <p class="text-subtitle-2 font-weight-bold grey--text">
          {{ item.product_subcategory }}
        </p>
        <p class="text-body secondary--text" style="line-height: 120%">
          {{ item.product_name }}
        </p>
        <p class="text-body secondary--text" v-if="item.volume_variation === 1">{{ item.product_volume_variation_name }}</p>
      </div>
      <div
        style="width: 7%; min-width: 120px"
        :class="{
          'align-start mt-2 align-self-end text-right': !$vuetify.breakpoint.smAndUp
        }"
      >
        <div class="wishlist-item-actions">
          <v-btn fab depressed color="white" x-small class="" v-if="item.stock_status === 'In Stock'" @click="selectItemForCart(item)">
            <v-icon color="primary" class="transparent text--lighten-1">$cart</v-icon>
          </v-btn>
          <v-btn
            fab
            depressed
            color="white"
            x-small
            :class="{
              'ml-3': item.stock_status === 'In Stock'
            }"
            @click="deleteItem"
          >
            <v-icon color="primary" class="transparent text--lighten-1">mdi-trash-can-outline</v-icon>
          </v-btn>
        </div>
        <div class="mb-4">
          <div v-if="item.agent_price" class="d-flex flex-column mt-4">
            <span class="orange--text text-subtitle-2 font-weight-medium" style="line-height: 90%">{{ $t('label.partnerPrice') }}</span>
            <span class="font-weight-bold orange--text text-subtitle-1">{{ `${item.currency} ${item.agent_price ? formatPrice(item.agent_price) : priceFormatter(item.final_price)}` }}</span>
          </div>
          <div v-else class="d-flex flex-column mt-4">
            <span class="font-weight-medium grey--text text--darken-2 text-subtitle-2 mb-2" style="line-height: 90%">{{ $t('label.retailPrice') }}</span>
            <span
              class="font-weight-bold grey--text text--darken-2 text-subtitle-1"
              :class="{
                'text-decoration-line-through': isDiscounted
              }"
              style="line-height: 110%"
            >
              {{ `${item.currency} ${item.agent_price ? formatPrice(item.agent_price) : formatPrice(item.final_price)}` }}
            </span>
            <span v-if="isDiscounted" class="grey--text text--darken-2 font-weight-bold text-subtitle-1" style="line-height: 120%">
              {{ `${item.currency} ${formatPrice(item.discounted_price)}` }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { localeHelper, uiHelper } from '@/utils'

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isDiscounted() {
      return this.item.discounted_price != null && this.item.discounted_price != ''
    }
  },
  methods: {
    // ...mapMutations('wishlist', ['selectItemForCart']),
    ...mapActions('wishlist', ['deleteWishlist']),
    async deleteItem() {
      await this.deleteWishlist([this.item.wish_id])
    },
    selectItemForCart() {
      this.$emit('addToCart', this.item)
    },
    formatPrice(val) {
      return uiHelper.priceFormatter(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.wishlist-image {
  width: 150px;
  height: 150px;
  object-fit: cover;

  @media only screen and (min-width: 640px) {
    width: 200px;
    height: 200px;
  }
  @media only screen and (min-width: 1800px) {
    width: 200px;
    height: 200px;
  }
}

.voucher-image {
  width: 150px;
  height: 150px;
  padding: 2% 15%;

  @media only screen and (min-width: 640px) {
    width: 200px;
    height: 200px;
  }
  @media only screen and (min-width: 1800px) {
    width: 200px;
    height: 200px;
  }
}

.unavailable-item {
  filter: opacity(0.6);
}

.discount {
  position: absolute;
  right: 8%;
  top: 4%;
  height: 40px;
  width: 40px;
  font-size: 0.75rem;
  line-height: 1;

  @media only screen and (min-width: 640px) {
    height: 50px;
    width: 50px;
    font-size: 0.8rem;
  }
  @media only screen and (min-width: 1800px) {
    height: 50px;
    width: 50px;
    font-size: 0.8rem;
  }
}

.w-max {
  width: max-content;
}
</style>
